export const PERMISSION_INSPECTOR_STORAGE_KEY =
  "sysAdminPermissionInspectorEnabled";
export const PERMISSION_INSPECTOR_TOGGLE_EVENT =
  "permission-inspector-toggle-changed";

const isBrowser = () => typeof window !== "undefined";

export const isPermissionInspectorEnabled = () => {
  if (!isBrowser()) {
    return false;
  }

  return localStorage.getItem(PERMISSION_INSPECTOR_STORAGE_KEY) === "true";
};

export const setPermissionInspectorEnabled = (isEnabled: boolean) => {
  if (!isBrowser()) {
    return;
  }

  localStorage.setItem(
    PERMISSION_INSPECTOR_STORAGE_KEY,
    isEnabled ? "true" : "false",
  );

  window.dispatchEvent(
    new CustomEvent(PERMISSION_INSPECTOR_TOGGLE_EVENT, {
      detail: { isEnabled },
    }),
  );
};
